import React, { type ReactElement } from "react";

import Spinner from "@shared/spinner";

interface Props {
  isLoading: boolean;
  text: string;
  children: ReactElement;
}

export const SavedViewsMenuLoadingRow = ({
  isLoading,
  text,
  children,
}: Props) => {
  if (isLoading) {
    return (
      <div className="flex items-center font-semibold">
        <Spinner colorClassname="mr-2 text-cosmic" />
        <div className="text-sm">{text}</div>
      </div>
    );
  }

  return children;
};
